export enum EReducerState {
  IDLE = ' IDLE',
  LOADING = 'LOADING',
  SYNCING = 'SYNCING',
  FAILED = 'FAILED',
}
